import React, { useContext, useEffect, useState } from 'react'
import './GameRate.css'
import marketRate from '../../images/market rate.png'
import gameRateAnna from '../../images/game-rate-anna.png'
import starlineRate from '../../images/market rate.png'
import axios from 'axios'
import { LoaderContext } from '../15-loader/LoaderProvider'

const GameRate = () => {

  const [marketApiData, setMarketApiData] = useState([]);
  const [starlineApiData, setStarlineApiData] = useState([]);
  const { setIsLoading } = useContext(LoaderContext);

  const getGameData = async (isStarline) => {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/web/gameRate?isStarline=${isStarline}`)
        .then((r) => {
          if (isStarline) {
            setStarlineApiData(r.data.data)
          } else {
            setMarketApiData(r.data.data)
          }
          setIsLoading(false)
        })
        .catch((err) => console.log(err.message));
    }

    useEffect(() => {
      getGameData(false)  // for market data
      getGameData(true)   // for starline data
    }, []);

  return (
    <div className='game-rate' id='gamerate'>

      <div className='game-rate-content'>

        <div className='container'>

          <div className='game-rate-content-heading' ><h2>GAME RATES</h2></div>

          <div className='game-rate-data'>

            <div className='market-game-rate' >

              <div className='market-game-rate-heading'><h5>MARKET</h5></div>
              <div className='market-game-rate-bg'><img src={marketRate} /></div>

              <div className='market-game-rate-data'>

                {
                  marketApiData.map((data) =>

                    <div key={data.id} className='market-game-rate-points'>
                      <h6>{data.Name}</h6>
                      <h6>{data.BaseRate} KA {data.Rate}</h6>
                    </div>

                  )
                }

              </div>

            </div>

            <div className='game-rate-anna' ><img src={gameRateAnna} /></div>

            <div className='starline-game-rate'>

              <div className='market-game-rate-heading'><h5>STARLINE</h5></div>
              <div className='market-game-rate-bg'><img src={starlineRate} /></div>

              <div className='market-game-rate-data'>

                {
                  starlineApiData.map((data) =>

                    <div key={data.id} className='market-game-rate-points'>
                      <h6>{data.Name}</h6>
                      <h6>{data.BaseRate} KA {data.Rate}</h6>
                    </div>

                  )
                }

              </div>

            </div>

          </div>

        </div>

      </div>

      <div className='game-rate-bg'></div>

    </div>
  )
}

export default GameRate
